<div class="error">
  <dgx-components-icon
    class="error__icon"
    size="xl"
    name="circle-exclamation"
  ></dgx-components-icon>

  <h1 class="error__title">Sorry, something went wrong</h1>
  <p>We’ve got your payment, but there was a problem with your order.</p>

  <section class="plan" *ngIf="planNumber">
    <p>Please call us with your plan number:</p>
    <p class="number" dgxQmSanitise="encrypt">{{ planNumber }}</p>
    <p>We’ll confirm your payment and finish setting things up.</p>
  </section>

  <section class="contact">
    <section>
      <dgx-components-icon name="phone"> </dgx-components-icon>
      <a href="tel:03330004970"> 0333 000 4970 </a>
    </section>
    <p class="open-hours">Opening hours: Monday to Friday 9am-5pm.</p>
  </section>

  <p class="call-cost">
    Calls cost the basic rate per minute plus your phone company’s access
    charge. From a mobile, they can cost much more.
  </p>

  <p class="error-code">Error code: 500</p>
</div>
